import { useSyncExternalStore } from 'react';

// Kept in memory on purpose: the hint is shown again after a reload, and is shared by every PDF field on the page.
let hasDragged = false;
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => hasDragged;

const markDragged = () => {
  if (hasDragged) return;
  hasDragged = true;
  listeners.forEach((listener) => listener());
};

export const resetDragHintForTests = () => {
  hasDragged = false;
  listeners.forEach((listener) => listener());
};

/** Tracks whether the patient has ever dragged a floating signature, so the "drag it" hint is only shown until then. */
export const useDragHint = () => {
  const dragged = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return { showHint: !dragged, markDragged };
};
